import React from 'react';
import {
	faGrid,
	faMap,
	faTableLayout,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Card,
	Flex,
} from 'antd';
import classNames from 'classnames';
import { EstimatorModeTypes } from '@shared/utils/constants';
import { useNavigationBlock } from '@client/lib/navigationBlock';
import { useEstimateChangesProvider } from '../context/EstimateChangesContext';
import { useGridChanges } from '../context/GridChangesContext';
import styles from './styles/ModePicker.module.css';

const ModePicker = ({
	mode,
	setMode,
}: {
	mode: EstimatorModeTypes;
	setMode: (newMode: EstimatorModeTypes) => void;
}) => {
	const { makeBlockable } = useNavigationBlock();
	const { onClearPendingChanges } = useEstimateChangesProvider();
	const { onClearGridChanges } = useGridChanges();

	const changeMode = makeBlockable((newMode: EstimatorModeTypes) => {
		if (newMode === mode) {
			return;
		}

		onClearPendingChanges();
		onClearGridChanges();
		setMode(newMode);
	});

	const ModeButton = ({ buttonMode }: { buttonMode: EstimatorModeTypes }) => {
		let icon = faTableLayout;

		if (buttonMode === EstimatorModeTypes.GRID) {
			icon = faGrid;
		} else if (buttonMode === EstimatorModeTypes.MAP) {
			icon = faMap;
		}

		return (
			<FontAwesomeIcon
				className={classNames(styles.modeButton, {
					[styles.active]: mode === buttonMode,
				})}
				onClick={() => changeMode(buttonMode)}
				data-testid={`estimator-mode-${buttonMode}`}
				fontSize={18}
				icon={icon}
			/>
		);
	};

	return (
		<Card className={styles.card}>
			<Flex className={styles.fullHeight} align="center" justify="space-between">
				<ModeButton buttonMode={EstimatorModeTypes.NORMAL} />
				<ModeButton buttonMode={EstimatorModeTypes.GRID} />
				<ModeButton buttonMode={EstimatorModeTypes.MAP} />
			</Flex>
		</Card>
	);
};

export default ModePicker;
